<template>
  <div>
    <review-list />
  </div>
</template>
<script>
import ReviewList from "@/components/supplier_management/review_management/ReviewList.vue";
export default {
  components: {
    ReviewList
  }
};
</script>
